// A reducer is a pure function that receives the state of the store and an action as parameters and then returns the updated state.

import { acChargingStationTypes } from '../acReduxExports';

// Declare an initial state to have some chargingStationData. The state object needs to match the type ChargingStationState - otherwise, TypeScript will throw an error.
const chargingStationInitialState: AcChargingStationState = {
	chargingStations: null,
	chargingStationsCount: 0,
	loader: false,
	chargingStationTableProps: {
		view: 'list',
		pageSize: 15,
		pageNumber: 1,
		order: 'ascending',
		sortBy: 'chargingStationName',
		searchTerm: '',
	},
	singleStationDetail: null,
	historyRecords: null,
	historyRecordCount: 0,
	historyRecordTableProps: {
		view: 'list',
		sortBy: '',
		order: 'descending',
		pageSize: 15,
		pageNumber: 1,
		searchTerm: '',
	},
};

// Reducer function that expects the previous state and an action to be able to update the store.
const acChargingStationReducer = (
	state: AcChargingStationState = chargingStationInitialState,
	action: AcChargingStationAction,
): AcChargingStationState => {
	switch (action.type) {
		case acChargingStationTypes.FETCH_AC_CHARGING_STATION_DATA:
			return {
				...state,
				chargingStations: action.chargingStations,
				chargingStationsCount: action.chargingStationsCount,
			};

		case acChargingStationTypes.SET_AC_CHARGING_STATIONS_TABLE_PROPS:
			return {
				...state,
				chargingStationTableProps: action.chargingStationTableProps,
			};
		case acChargingStationTypes.CLEAR_AC_CHARGING_STATION_LIST_DATA:
			return {
				...state,
				chargingStationTableProps: {
					view: 'list',
					pageSize: state.chargingStationTableProps?.pageSize || 15,
					pageNumber: state.chargingStationTableProps?.pageNumber || 1,
					order: state.chargingStationTableProps?.order || 'ascending',
					sortBy: state.chargingStationTableProps?.sortBy || '',
					searchTerm: '',
				},
			};
		case acChargingStationTypes.FETCH_AC_SINGLE_STATION_DETAIL:
			return {
				...state,
				singleStationDetail: action.singleStationDetail,
			};
		case acChargingStationTypes.CLEAR_UPDATED_AC_STATION_DETAIL_DATA:
			return {
				...state,
				singleStationDetail: null,
			};

		default:
			return state;
	}
};

export default acChargingStationReducer;
